/**
 * Clones a FileItem object.
 * @param fileItem - The FileItem to clone.
 * @returns A new FileItem object with the same properties as the original.
 */
export function cloneFileItem(fileItem) {
    return { ...fileItem };
}
//# sourceMappingURL=FileItem.js.map